import { render, staticRenderFns } from "./StoreInfo.vue?vue&type=template&id=fda2c462"
import script from "./StoreInfo.vue?vue&type=script&lang=js"
export * from "./StoreInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports